function manageUserStatusDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/manage-user-status/manage-user-status-dialog.html?$$REVISION$$'
  }
}

export { manageUserStatusDialog }
